import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import type { ConversationMessageModel } from "#features/conversations/types/ConversationMessageModel.ts";
import { Flex } from "@hopper-ui/components";
import { InfoIcon } from "@hopper-ui/icons";

interface Props {
    message: ConversationMessageModel;
}

export const AssistantMessageCancelled = ({ message: { assistantStatus } }: Props) => {
    const { tShared } = useSharedTranslation();

    if (assistantStatus !== "cancelled") {
        return null;
    }

    return (
        <Flex
            alignItems="center"
            gap="inline-sm"
            fontSize="body-sm"
            color="neutral-weak"
        >
            <InfoIcon fill="currentcolor" size="sm" />
            {tShared("cancelled")}
        </Flex>
    );
};
